import React from 'react';
import styled from 'styled-components';
import Text from '@service-victoria/component-library/components/Text';
import Page from '@service-victoria/component-library/components/Page';
import { Button } from '@service-victoria/component-library/components/Button';
import { constants } from 'utils';
import bannerImg from 'assets/great-ocean-image.jpg';
import * as Styled from './styled';

const PageWrapper = styled(Page)``;

const Maintenance: React.FC = () => {
  const handleButton = () => {
    window.location.href = 'https://www.service.vic.gov.au';
  };

  return (
    <PageWrapper
      title={constants.Page.title}
      showFooter={true}
      breadCrumbs={constants.breadCrumbs}
      imgUrl={bannerImg}
      loading={false}
      error={undefined}
      opacityBetweenLoading={0}>
      <Styled.Wrapper>
        <Text.Heading.H1 style={{ fontWeight: 600 }}>We&apos;re improving things</Text.Heading.H1>
        <Styled.Spacer32 />
        <Text.Heading.H3 style={{ fontWeight: 600 }}>
          The site&apos;s unavailable while we make a few small changes.
        </Text.Heading.H3>
        <Styled.Spacer16 />
        <Text.Body>
          Please try again{' '}
          {window.ENV.etaBackOnline ? `after ${window.ENV.etaBackOnline}` : 'later'}.
        </Text.Body>
        <Styled.Spacer32 />
        <Button onClick={handleButton}>Back to home</Button>
      </Styled.Wrapper>
    </PageWrapper>
  );
};

export default Maintenance;
